import { useAppointmentModal } from "@/contexts/AppointmentModalContext";
import { useQuery } from "@tanstack/react-query";
import { fetchAppointmentConsumables } from "@/lib/services/appointmentModalService";

/**
 * Hook to get consumables info for the current appointment in the modal context.
 * Returns the React Query result for appointment with consumables.
 */
export function useAppointmentModalConsumablesInfo() {
  const { appointmentId } = useAppointmentModal();
  return useQuery({
    queryKey: ["appointmentConsumables", appointmentId],
    queryFn: () => fetchAppointmentConsumables(appointmentId ?? 0),
    enabled: !!appointmentId,
    staleTime: 0, // Data is immediately stale
    gcTime: 0, // No caching after component unmounts (if supported)
    refetchOnMount: 'always', // Refetch on every mount
  });
}
